import { render } from "./AddElementPopover.vue?vue&type=template&id=4fb4a1a3"
import script from "./AddElementPopover.vue?vue&type=script&lang=js"
export * from "./AddElementPopover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__